import { render } from "./AddToCalendar.vue?vue&type=template&id=aebdc990&scoped=true"
import script from "./AddToCalendar.vue?vue&type=script&lang=js"
export * from "./AddToCalendar.vue?vue&type=script&lang=js"

import "./AddToCalendar.vue?vue&type=style&index=0&id=aebdc990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aebdc990"]])

export default __exports__